import { ConsentView } from "@/features/consent-view";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../httpClient";
import { verifyRoles } from "../../../utils/verifyRoles";

export const Route = createFileRoute(
  "/dashboard/consents/$tenantId/$consentId",
)({
  component: ConsentView,
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
  loader: async ({
    context: { queryClient },
    params: { consentId, tenantId },
  }) => {
    await queryClient.ensureQueryData({
      queryKey: ["consent", consentId],
      queryFn: async () => {
        const httpClient = isomorphicHttpClient();

        const { data, error } = await httpClient.GET(
          "/v1/consents/{tenantId}/{consentId}",
          {
            params: {
              path: { tenantId, consentId },
            },
          },
        );

        if (error) {
          throw new Error(error.message);
        }

        return data;
      },
    });
  },
});
